module.exports = __webpack_public_path__ + "img/logo@3x.b73c7f9a.png";